import { useQuery } from 'react-query';

import { getResourceListForChart as queryFn } from 'api/endPoints/getResourceListForChart';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetResourceListForChart = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getResourceListForChart', params],
        queryFn: () =>
            queryFn({
                latestVersion: params.latestVersion as number,
            }),
        enabled: Boolean(params.latestVersion),
    });
};

export interface QueryResponse {
    value: number;
    label: string;
    count: number;
}

interface QueryParams {
    latestVersion?: number;
}
